import * as types from "../../constants/actionTypes";

export const setLoader = (data) => {
    return {
        type: types.DASHBOARD_DOKTER_SET_LOADER,
        payload: data
    }
};

export const  getListKonsultasi = (value) => {
    return ({
        type: types.GET_LIST_KONSULTASI,
        value
    })
}


